import { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ReceiptContainer from './ReceiptContainer'
import { BackButton } from '../../../components/UI/ComponentsUI';
import { showMessageToastCustom } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import ContainerService from '../../../services/ContainerService';

const ReceiptContainerMain = (props) => {
    var containerYard = props.history?.location.state?.containerYard
    const [items, setItems] = useState([]);

    const onSubmit = (container) => {
        if (containerYard) {
            props.getContainer({ name: container }, r => {
                if (r.containerItem?.length > 0) {
                    setItems(r.containerItem)
                } else {
                    showMessageToastCustom('Não encontrado',
                        'Nenhum container encontrado',
                        3000, 'mdi mdi-alert-circle-outline red-text');
                }
            });
        } else {
            props.getReceipts({ container: container }, r => {
                if (r.data?.length > 0) {
                    setItems(r.data)
                } else {
                    showMessageToastCustom('Não encontrado',
                        'Nenhum container encontrado',
                        3000, 'mdi mdi-alert-circle-outline red-text');
                }
            });
        }
    }

    return (
        <div className="">
            <BackButton {...props} />
            <ReceiptContainer
                items={items}
                containerYard={containerYard}
                onCancel={() => setItems([])}
                onSubmit={onSubmit} />
        </div>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceipts: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceipts(filter, callback));
        },
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainerMvm(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptContainerMain));